import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { Row, Col } from 'styled-bootstrap-grid'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { bindActionCreators } from 'redux'
import { AppState, Dispatch } from 'store/types'
import TextInput from 'components/UI/TextInput'
import { Modal } from 'components/UI/Modal'
import { Button } from 'components/UI/Button'
import { Link } from 'components/UI/Link'
import { ContentBlock } from 'components/common'
import { logout } from 'ducks/auth/operations'
import { routePath } from 'routes'

interface State {
  showModal: boolean
}

class EstimateMyDetailPage extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      showModal: false
    }
  }

  onShowModal = () => this.setState({ showModal: true })
  onCloseModal = () => this.setState({ showModal: false })

  onSendEstimate = () => {}

  render() {
    const { location } = this.props
    const { showModal } = this.state

    return (
      <WrapBlock>
        <HeadTitle>
          <h1>Your estimate</h1>
          <RightHeadTitle>
            <Button variant={'text'}>Download</Button>
            <Button variant={'text'}>Print</Button>
            <Button variant={'text'} onClick={this.onShowModal}>
              Email
            </Button>
          </RightHeadTitle>
        </HeadTitle>

        <ContentBlock isCentered={false}>
          <TitleBlock>
            <h1>Estimate #27849</h1>
            <h3>Date Created: August 18, 2019</h3>
          </TitleBlock>

          <Row>
            <Col xl={4} md={6}>
              <Option>
                <Label>Patient</Label>
                <Value>John Smith</Value>
              </Option>
            </Col>
            <Col xl={4} md={6}>
              <Option>
                <Label>Member ID</Label>
                <Value>78924000</Value>
              </Option>
            </Col>
            <Col xl={4} md={6}>
              <Option>
                <Label>DOB</Label>
                <Value>12/11/1982</Value>
              </Option>
            </Col>
            <Col xl={4} md={6}>
              <Option>
                <Label>Gender</Label>
                <Value>Male</Value>
              </Option>
            </Col>
            <Col xl={4} md={6}>
              <Option>
                <Label>Appointment Type</Label>
                <Value>Name</Value>
              </Option>
            </Col>
            <Col xl={4} md={6}>
              <Option>
                <Label>Physician</Label>
                <Value>Dr. Donald</Value>
              </Option>
            </Col>
            <Col xl={4} md={6}>
              <Option>
                <Label>Service Code</Label>
                <Value>Name</Value>
              </Option>
            </Col>
          </Row>

          <Row>
            <Col xl={6} md={6}>
              <Estimated>
                <EstimateTitle>Estimated Total Charges</EstimateTitle>
                <EstimatePrice>$1,243.00</EstimatePrice>
              </Estimated>
            </Col>
            <Col xl={6} md={6}>
              <Estimated>
                <EstimateTitle>Estimated Deductible</EstimateTitle>
                <EstimatePrice>$1,243.00</EstimatePrice>
              </Estimated>
            </Col>
            <Col xl={6} md={6}>
              <Estimated>
                <EstimateTitle>Estimated Insurance Adjustment</EstimateTitle>
                <EstimatePrice>$1,243.00</EstimatePrice>
              </Estimated>
            </Col>
            <Col xl={6} md={6}>
              <Estimated>
                <EstimateTitle>Estimated Co-Insurance</EstimateTitle>
                <EstimatePrice>$1,243.00</EstimatePrice>
              </Estimated>
            </Col>
            <Col xl={6} md={6}>
              <Estimated>
                <EstimateTitle>Estimated Allowed Amount</EstimateTitle>
                <EstimatePrice>$1,243.00</EstimatePrice>
              </Estimated>
            </Col>
            <Col xl={6} md={6}>
              <Estimated>
                <EstimateTitle>Estimated Co-Pay</EstimateTitle>
                <EstimatePrice>$1,243.00</EstimatePrice>
              </Estimated>
            </Col>
            <Col xl={6} md={6}>
              <Estimated>
                <EstimateTitle>Estimated Insurance Payment</EstimateTitle>
                <EstimatePrice>$1,243.00</EstimatePrice>
              </Estimated>
            </Col>
            <Col xl={6} md={6}>
              <Estimated>
                <EstimateTitle>Estimated Balance Due</EstimateTitle>
                <EstimatePrice>$1,243.00</EstimatePrice>
              </Estimated>
            </Col>
            <Col xl={6} md={6}>
              <Estimated>
                <EstimateTitle>Estimated Responsibility</EstimateTitle>
                <EstimatePrice>$1,243.00</EstimatePrice>
              </Estimated>
            </Col>
          </Row>

          <Row>
            <Col xl={6} md={6}>
              <Estimated>
                <EstimateTitle>Estimated Total Charges</EstimateTitle>
                <EstimatePrice>$1,243.00</EstimatePrice>
              </Estimated>
            </Col>
            <Col xl={6} md={6}>
              <Estimated>
                <EstimateTitle>Estimated Deductible</EstimateTitle>
                <EstimatePrice>$1,243.00</EstimatePrice>
              </Estimated>
            </Col>
            <Col xl={6} md={6}>
              <Estimated>
                <EstimateTitle>Estimated Insurance Adjustment</EstimateTitle>
                <EstimatePrice>$1,243.00</EstimatePrice>
              </Estimated>
            </Col>
            <Col xl={6} md={6}>
              <Estimated>
                <EstimateTitle>Estimated Co-Insurance</EstimateTitle>
                <EstimatePrice>$1,243.00</EstimatePrice>
              </Estimated>
            </Col>
            <Col xl={6} md={6}>
              <Estimated>
                <EstimateTitle>Estimated Allowed Amount</EstimateTitle>
                <EstimatePrice>$1,243.00</EstimatePrice>
              </Estimated>
            </Col>
            <Col xl={6} md={6}>
              <Estimated>
                <EstimateTitle>Estimated Co-Pay</EstimateTitle>
                <EstimatePrice>$1,243.00</EstimatePrice>
              </Estimated>
            </Col>
            <Col xl={6} md={6}>
              <Estimated>
                <EstimateTitle>Estimated Insurance Payment</EstimateTitle>
                <EstimatePrice>$1,243.00</EstimatePrice>
              </Estimated>
            </Col>
            <Col xl={6} md={6}>
              <Estimated>
                <EstimateTitle>Estimated Balance Due</EstimateTitle>
                <EstimatePrice>$1,243.00</EstimatePrice>
              </Estimated>
            </Col>
            <Col xl={6} md={6}>
              <Estimated>
                <EstimateTitle>Estimated Responsibility</EstimateTitle>
                <EstimatePrice>$1,243.00</EstimatePrice>
              </Estimated>
            </Col>
          </Row>


          <ButtonBlock>
            <Button variant={'default'}>Download</Button>
            <Button variant={'default'}>Print</Button>
            <Button variant={'default'}>Email</Button>
          </ButtonBlock>

          <Comment>
            This is an estimate of your procedure costs. Costs are subject to
            change.
          </Comment>
        </ContentBlock>

        <BottomBlock>
          {location.state &&
          // @ts-ignore
          location.state.from &&
          // @ts-ignore
          location.state.from.pathname === routePath.ESTIMATE_CREATE ? (
            <>
              <div />
              <Link to={routePath.ESTIMATES_PAGE} variant={'default'}>
                Done
              </Link>
            </>
          ) : (
            <Link to={routePath.ESTIMATES_PAGE} variant={'secondary'}>
              Back
            </Link>
          )}
        </BottomBlock>

        <Modal
          modal={{
            title: 'Email Estimate',
            content: (
              <div>
                <TextInput placeholder={'Enter email address'} />
              </div>
            ),
            footer: (
              <Fragment>
                <Button variant={'text'} onClick={this.onCloseModal}>
                  Cancel
                </Button>
                <Button variant={'default'} onClick={this.onSendEstimate}>
                  Send
                </Button>
              </Fragment>
            )
          }}
          isOpen={showModal}
        />
      </WrapBlock>
    )
  }
}

// tslint:disable-next-line:no-empty-interface
interface ReceivedProps {}

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>
type Props = StateProps &
  DispatchProps &
  ReceivedProps &
  RouteComponentProps<any>

const mapStateToProps = (state: AppState) => ({
  isAccountCreated: state.auth.registrationData
})

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({ logout }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EstimateMyDetailPage)

const BottomBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
const ButtonBlock = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 2rem;

  button {
    margin-right: 20px;
  }
`

export const Comment = styled.div`
  font-size: 15px;
  color: #89919c;
`

const Estimated = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #ffffff;
  padding: 2rem;
  margin-bottom: 2rem;
`
const EstimateTitle = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: #152735;
  margin-bottom: 0.5rem;
`
const EstimatePrice = styled.p`
  font-size: 24px;
  color: #152735;
`
const Option = styled.div`
  margin-bottom: 2rem;
`
const Label = styled.p`
  color: #89919c;
  font-size: 14px;
`
const Value = styled.p`
  color: #152735;
  font-size: 21px;
`
const TitleBlock = styled.div`
  margin-bottom: 3rem;
  width: 100%;
  border-bottom: 1px solid #eeeeee;

  h1 {
    margin-bottom: 1rem;
  }

  h3 {
    color: #585d64;
    margin-bottom: 2.5rem;
  }
`

const WrapBlock = styled.div``

const RightHeadTitle = styled.div`
  display: flex;
  flex-direction: row;

  button {
    margin-left: 30px;
    min-width: auto;
  }
`

const HeadTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2.5rem;
`
